import moment from 'moment'
const monthRangeFromBegin = () => {
  const start = moment('2020-03-01', 'YYYY-MM-DD')
  const end = moment(new Date())
  const res = []
  while (
    end.valueOf() > start.valueOf() ||
    start.format('M') === end.format('M')
  ) {
    res.push(start.format('MM.YY'))
    start.add(1, 'month')
  }
  return res
}

export default monthRangeFromBegin
